import { useEffect, useState } from "react";
import { flushQueue, queuedCount, isOffline } from "../lib/offlineQueue";
import { WifiOff, Cloud, CloudUpload, Check } from "lucide-react";

export default function OfflineIndicator() {
  const [offline, setOffline] = useState(isOffline());
  const [count, setCount] = useState(queuedCount());
  const [syncing, setSyncing] = useState(false);
  const [justSynced, setJustSynced] = useState(0);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    const upd = () => setCount(queuedCount());
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    window.addEventListener("dbs-queue-changed", upd);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      window.removeEventListener("dbs-queue-changed", upd);
    };
  }, []);

  const sync = async () => {
    setSyncing(true);
    const r = await flushQueue();
    setSyncing(false);
    setJustSynced(r.sent);
    setTimeout(() => setJustSynced(0), 3000);
  };

  // Nothing to show
  if (!offline && count === 0 && !justSynced) return null;

  return (
    <div
      className="fixed z-40 flex items-center gap-2 px-3 py-2 border shadow-lg"
      style={{
        top: 12, right: 12,
        background: offline ? "rgba(239,68,68,0.15)" : "var(--surface)",
        borderColor: offline ? "rgba(239,68,68,0.4)" : "var(--primary)",
        fontSize: 12,
      }}
      data-testid="offline-indicator"
    >
      {offline ? (
        <>
          <WifiOff size={14} color="#EF4444" />
          <span style={{ color: "#FCA5A5" }}>Sem conexão</span>
          {count > 0 && <span className="mono" style={{ color: "#FACC15" }}>· {count} pendente(s)</span>}
        </>
      ) : justSynced > 0 ? (
        <>
          <Check size={14} color="#22C55E" />
          <span style={{ color: "#86EFAC" }}>{justSynced} enviado(s)</span>
        </>
      ) : (
        <>
          <Cloud size={14} color="#FACC15" />
          <span style={{ color: "#FDE68A" }}>{count} pendente(s)</span>
          <button className="btn btn-primary" style={{ padding: "4px 10px", fontSize: 12 }} onClick={sync} disabled={syncing} data-testid="sync-now">
            <CloudUpload size={12} /> {syncing ? "Enviando..." : "Sincronizar"}
          </button>
        </>
      )}
    </div>
  );
}
